export default "__VITE_ASSET__Bd0zFieb__"